import React from "react";
import white_logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";

import fb from "../assets/images/fb.png";
import insta from "../assets/images/instagram.png";
import yt from "../assets/images/youtube.png";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const scrollToSection = (sectionId) => {
    scroller.scrollTo(sectionId, {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };
  return (
    <div className="footer" style={{ marginTop: "50px" }}>
      <div className="container pt-5">
        <div className="row">
          <div className="col-md-3 col-12 text-white">
            <img
              alt="Logo"
              src={white_logo}
              className="footer-logo"
              width={"100px"}
               data-aos="fade-up" data-aos-delay="100"
            />
            <p style={{ fontSize: "16px", marginTop: "1rem" }}  data-aos="fade-up" data-aos-delay="150">Global Arabian Trading Bank</p>
            <p  data-aos="fade-up" data-aos-delay="200" className="fw-lighter mt-3" style={{ fontSize: "13px" }}>
            Deposit, withdraw, request loan and manage you
            complete investments portfolio
            </p>
            <div data-aos="fade-up" data-aos-delay="250" className="mt-3">
              <p style={{ fontSize: "13px", marginBottom: "5px" }}>
                <strong>Contact Details:</strong>
              </p>
              <p style={{ fontSize: "13px", marginBottom: "5px" }}>
                <strong>UAE:</strong> <a href="tel:+971542210088" className="text-white text-decoration-none">+971 54 22 100 88</a>
              </p>
              <p style={{ fontSize: "13px", marginBottom: "5px" }}>
                <strong>Denmark:</strong> <a href="tel:+4527599957" className="text-white text-decoration-none">+45 27599957</a>
              </p>
              <p style={{ fontSize: "13px" }}>
                <a href="mailto:Customerservice@globalarabiantrading.com" className="text-white text-decoration-none">Customerservice@globalarabiantrading.com</a>
              </p>
            </div>
          </div>
          <div className="col-md-3 col-6 text-white top-links">
            <h4 className="fw-semibold" data-aos="fade-up" data-aos-delay="100">Top Links</h4>
            <div className="d-flex justify-content-between">
              <nav className="nav footer-nav flex-column py-3 me-3" data-aos="fade-up" data-aos-delay="200">
                <a 
                  className="nav-link text-white px-0" 
                  href="#home"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("home");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Home
                </a>
                <a 
                  className="nav-link text-white px-0" 
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("about");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  About Us
                </a>
                <a 
                  className="nav-link text-white px-0" 
                  href="#whyChooseUs"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("whyChooseUs");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Why Choose Us
                </a>
                <a 
                  className="nav-link text-white px-0" 
                  href="#screenshort"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("screenshort");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Screenshots
                </a>
                <a 
                  className="nav-link text-white px-0" 
                  href="#downloadApp"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("downloadApp");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Download App
                </a>
              </nav>
            </div>
          </div>
          <div className="col-md-3 col-6 text-white useful-links">
            <h4 className="fw-semibold" data-aos="fade-up" data-aos-delay="100">Usefull Links</h4>
            <div className="d-flex justify-content-between">
              <nav className="nav footer-nav flex-column py-3 me-3" data-aos="fade-up" data-aos-delay="200">
                <Link to="/privacy" className="nav-link text-white px-0">
                  Privacy Policy
                </Link>
                <Link to="/terms" className="nav-link text-white px-0">
                  Terms
                </Link>
                <a className="nav-link text-white px-0" href="#">
                  Help Center
                </a>
                <a className="nav-link text-white px-0" href="#">
                  Transactions
                </a>
                <a className="nav-link text-white px-0" href="#">
                  Condition
                </a>
              </nav>
            </div>
          </div>
          <div className="col-md-3 col-6 text-white social-links">
            <h4 className="fw-semibold" data-aos="fade-up" data-aos-delay="100">Social Links</h4>
            <div className="">
              <nav className="nav footer-nav flex-column py-3 me-3 social-icons-size"  data-aos="fade-up" data-aos-delay="200">
                <a className="nav-link text-white px-0" href="#" target="_blank" rel="noopener noreferrer">
                  <img src={fb} className="me-1" alt="Facebook" /> <span>Facebook</span>
                </a>
                <a className="nav-link text-white px-0" href="#" target="_blank" rel="noopener noreferrer">
                  <img src={insta} className="me-1" alt="Instagram" /> <span>Instagram</span>
                </a>
                <a className="nav-link text-white px-0" href="#" target="_blank" rel="noopener noreferrer">
                  <img src={yt} className="me-1" alt="Youtube" /> <span>Youtube</span>
                </a>
                <a className="nav-link text-white px-0" href="#" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin className="me-1" size={20} /> <span>LinkedIn</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div
        className="footer-bottom p-3 mt-3"
        style={{ background: "rgba(39, 39, 39, 1)" }}
      >
        <div className="container my-auto d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-center">
          <div className="copyright text-center text-md-start my-auto text-white mb-3 mb-md-0">
            <span className="copyright-txt" style={{ fontSize: "15px" }}>
              © Copyrights 2025 <span style={{ color: "#FDCD26" }}>Global Arabian Trading </span>LLC FZ. All rights reserved.
            </span>
          </div>
          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 gap-md-3">
            <a href="#" className="text-light copyright-txt text-decoration-none" style={{ fontSize: "15px" }}>Help & Center</a>
            <span className="text-light d-none d-md-inline">|</span>
            <a href="#" className="text-light copyright-txt text-decoration-none" style={{ fontSize: "15px" }}>Refund Request</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
